import { Injectable } from '@angular/core';
// import { Headers, Http } from '@angular/http';

import { Http } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import'rxjs/add/operator/toPromise';
import'rxjs/add/operator/catch';
import'rxjs/add/operator/map';
import'rxjs/add/operator/concatMap';
import'rxjs/add/operator/filter';
import'rxjs/add/operator/reduce';

import { ConfigService } from '../config/config.service';
import { CountyTaxRate } from './county-tax-rate';
export class SalesTaxService {
    title = 'Sales-Tax Service';
private salesTaxUrl = '';
private config: any;
private countyTaxRates: Observable<CountyTaxRate[]>;
private countyTaxRatesStream: Observable<CountyTaxRate>;
private countyTaxRate: Observable<number>;
/**
 * @param {?} http
 * @param {?} configService
 */
constructor(
private http: Http,
private configService: ConfigService
    ) {
        this.configService.getConfig((configuration:any) => {
            this.config = configuration;
            this.salesTaxUrl = this.config.baseUrl + '/sales-tax';

            this.getCountyTaxRates();
        });
    }
/**
 * @return {?}
 */
getCountyTaxRates(): Observable<CountyTaxRate[]> {

        this.countyTaxRates = this.http.get(this.salesTaxUrl).map(res => res.json());
        
        return this.countyTaxRates;
    }
/**
 * @return {?}
 */
getCountyTaxRatesStream(): Observable<CountyTaxRate>{
        this.countyTaxRatesStream = this.countyTaxRates.concatMap((data) => {
            return data;
        });

        return this.countyTaxRatesStream;
    };
/**
 * @param {?} county
 * @return {?}
 */
getCountyTaxRate(county: string): Observable<number> {
        this.countyTaxRate = this.getCountyTaxRatesStream()
        .filter((countyTaxRate)=>{
            return countyTaxRate.county == county;
        })
        .reduce((acc, countyTaxRate) => acc + countyTaxRate.surtax, 0);
        
        return this.countyTaxRate;
    };



static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
{type: ConfigService, },
];
}

function SalesTaxService_tsickle_Closure_declarations() {
/** @type {?} */
SalesTaxService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SalesTaxService.ctorParameters;
/** @type {?} */
SalesTaxService.prototype.title;
/** @type {?} */
SalesTaxService.prototype.salesTaxUrl;
/** @type {?} */
SalesTaxService.prototype.config;
/** @type {?} */
SalesTaxService.prototype.countyTaxRates;
/** @type {?} */
SalesTaxService.prototype.countyTaxRatesStream;
/** @type {?} */
SalesTaxService.prototype.countyTaxRate;
/** @type {?} */
SalesTaxService.prototype.http;
/** @type {?} */
SalesTaxService.prototype.configService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
